import UserCreated from '../../components/Admin/Authentication/UserCreated.vue';

import FinishSigning from '../../components/Admin/Authentication/FinishSigning.vue';

const routes = [
  {
    path: '/deleteaccount',
    name: 'deleteaccount',
    component: () => import('../../components/DeleteAccount.vue'),
  },
  {
    path: '/cat/:category',
    //component: () => import('../../components/FrontLayout/frontpage'),
    component: () => import('../../components/FrontLayout/Category/categories2.vue'),
    name: 'home',
  },
  {
    // path: '/searchLanding/:pagetype',
    path: '/searchLanding/:pagetype/:suggestion',
    component: () => import('../../components/FrontLayout/SearchLanding/search_landing'),
    name: 'SearchLanding',
  },

  {
    path: '/:pagename/:domain/:id/:ttype?/:user_id?',
    component: () => import('../../components/FrontLayout/hirecategory.vue'),
    name: 'HireCategory',
  },
  {
    path: '/auth/:provider/callback',
    component: {
      template: '<div class="auth-component"></div>',
    },
  },

  {
    path: '/cat/:domain/:category?',
    component: () => import('../../components/FrontLayout/Category/categories2.vue'),
    name: 'Categorydata',
    props: true,
  },
  {
    path: '/payment',
    component: () => import('../../components/FrontLayout/Category/payment'),
    name: 'CheckPayment',
  },
  {
    path: '/proposalDetail/:proposal_id',
    component: () => import('../../components/FrontLayout/Proposal/new_proposaldetail'),
    name: 'proposalDetail',
  },
  {
    path: '/jobdetailsbid/:project/:projectid/:projectType',
    component: () => import('../../components/FrontLayout/Project/projectfrontbid'),
    name: 'jobdetailforbid',
  },

  {
    path: '/project/:project/:project_id?',
    component: () => import('../../components/FrontLayout/Project/projectfrontbid'),
    name: 'projectsbid',
  },
  {
    path: '/zd/usercart',
    component: () => import('../../components/FrontLayout/Cart/cart'),
    name: 'usercart',
  },
  {
    path: '/zd/confirmorder',
    component: () => import('../../components/FrontLayout/Cart/confirmorder'),
    name: 'confirmorder',
    props: true,
  },

  {
    path: '/zd/confirmhire',
    component: () => import('../../components/FrontLayout/Project/confirmhire'),
    name: 'confirmhire',
    props: true,
  },

  {
    path: '/admin/login',
    component: () => import('../../components/Admin/Authentication/index'),
    children: [
      {
        path: '',
        component: () => import('../../components/Admin/Authentication/AdminLogin'),
      },
    ],
  },
  {
    // path: '/viewtalents/:domainId/:categoryId/:userId',
    path: '/zd/viewtalents',
    component: () => import('../../components/FrontLayout/Category/viewTalents.vue'),
    name: 'ViewTalents',
  },

  {
    path: '/courseDetail/:class_id',
    component: () => import('../../components/FrontLayout/Trainings/coursedetails'),
    name: 'courseDetail',
  },
  {
    path: '/zd/leaveReview',
    component: () => import('../../components/FrontLayout/Trainings/leaveReview'),
    name: 'leaveReview',
  },

  {
    path: '/account/login',
    component: () => import('../../components/FrontLayout/Account/login'),
    name: 'login',
  },
  {
    path: '/viewtrainerProfile/:userId',
    component: () =>
      import('../../components/FrontLayout/Trainings/TrainerProfile/viewTrainerProfile.vue'),
    name: 'ViewTrainerProfile',
  },

  {
    path: '/zd/info',
    component: () => import('../InformativeScreens/informative.vue'),
    name: 'Informative',
  },

  {
    path: '/zd/testCat',
    component: () => import('../FrontLayout/NewDashboard/cat.vue'),
    name: 'testCat',
  },

  {
    path: '/zd/projectPost/:hireto_userid?',
    component: () => import('../../components/Seller/Project/projectpost'),
    name: 'postProject',
  },
  // {
  //     path: '/zd/newuserlogin',
  //     component:()=>import('../Admin/Authentication/AccountloginFigma'),
  //     name: 'New Login',
  // },
  {
    path: '/zd/newforget',
    component: () => import('../Admin/Authentication/AccountForgetFigma'),
    name: 'New Login',
  },
  {
    path: '/zd/newsignup',
    component: () => import('../Admin/Authentication/SignupFigma'),
    name: 'New Login',
  },
  {
    path: '/zd/newsignupform',
    component: () => import('../Admin/Authentication/signupformFigama'),
    name: 'New Login',
  },
  {
    path: '/user/created',
    name: 'userscreated',
    component: UserCreated,
  },

  {
    path: '/signup/finish',
    name: 'signupfinish',
    component: FinishSigning,
  },
  {
    path: '/signup/finish/newclient',
    name: 'signupFinishClient',
    component: FinishSigning,
  },
  {
    path: '/signup/finish/freelancer',
    name: 'signupFinishFreelancer',
    component: FinishSigning,
  },
  {
    path: '/signup/finish/student',
    name: 'signupFinishStudent',
    component: FinishSigning,
  },
  {
    path: '/signup/finish/tutor',
    name: 'signupFinishTrainer',
    component: FinishSigning,
  },
];
export default routes;
